const __vite_glob_0_41 = "<svg xmlns=\"http://www.w3.org/2000/svg\" data-name=\"Website Icons\" viewBox=\"0 0 100 100\"><path d=\"M85.16 67.16c-.51.56-1.2.83-1.89.83-.62 0-1.24-.22-1.74-.68L49.99 38.2 18.45 67.18c-1.04.96-2.66.9-3.62-.14s-.9-2.65.14-3.61l33.28-30.72a2.56 2.56 0 0 1 3.48 0l33.28 30.72c1.02 1.1 1.1 2.7.14 3.74Z\"/></svg>";

export { __vite_glob_0_41 as default };
